import { Modal } from 'antd';
import Colors from 'assets/Colors';
import s from './styles';

function CustomModalAlerts({
  width = 428,
  height = 234,
  titleAlert = [],
  info1 = [],
  info2 = [],
  button1 = [],
  onclick1 = [],
  button2 = [],
  onclick2 = [],
  ...props
}) {
  return (
    <Modal
      width={width}
      height={height}
      centered
      footer={null}
      bodyStyle={{ padding: 0, overflow: 'auto' }}
      closable={false}
      maskStyle={{ backdropFilter: 'blur(10px)' }}
      {...props}
    >
      <s.Wrapper>
        <s.Title>{titleAlert}</s.Title>
      </s.Wrapper>

      <s.WrapperContents>
        <s.info>{info1}</s.info>
        <s.info>{info2}</s.info>
      </s.WrapperContents>

      <s.Line />

      <s.WrapperButtons>
        <s.Button onClick={() => onclick1()}>{button1}</s.Button>
        {button2.length > 0 && (
          <s.Button
            style={{
              backgroundColor: '#fff',
              color: Colors.primary,
            }}
            onClick={() => onclick2(false)}
          >
            {button2}
          </s.Button>
        )}
      </s.WrapperButtons>
    </Modal>
  );
}

export default CustomModalAlerts;
